import Vue from "vue";
import { plugin } from "echarts-for-vue";
import * as echarts from "echarts";

Vue.use(plugin, { echarts });
